import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Fieldset } from "primereact/fieldset";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import RotuloSeplag from "../../../../../components/RotuloSeplag";
import { printToast } from "../../../../../config/global";
import {
  buscaAnaliseAcaoIndicador,
  buscaIndicadorPorIdenPtaFiplan,
  deletarAnaliseAcaoIndicador,
  editarAnaliseAcaoIndicador,
  salvarAnaliseAcaoIndicador,
} from "../../../../../service/Rag/AvaliacaoAcao";
import ModalSeplag from "../../../../../components/ModalSeplag";
import { buscarApuracaoByIndenIndicador } from "../../../../../service/Rag/AvaliacaoPrograma";
import CardSeplagScrol from "../../../../../components/CardSeplag/CardSeplagScrol";

const AvaliacaoAcaoRagIndicador = (props) => {
  const [qtdMaxCaracteres, setQtdMaxCaracteres] = useState(4000);
  const [listaIndicadores, setListaIndicadores] = useState();
  const [indicadorSelecionado, setIndicadorSelecionado] = useState(null);
  const [dadosMetaPPA, setDadosMetaPPA] = useState();
  const [analiseAcaoIndicador, setAnaliseAcaoIndicador] = useState({
    idenPtaMonitora: null,
    idenPtaFiplanIndicador: null,
    tipoAnaliseAcaoIndicador: 0,
    descAnaliseAcaoIndicador: "",
    statAnaliseAcaoInd: 1,
    dataApuracao: "",
    valrApurado: 0,
  });
  const [editAnaliseAcaoIndicador, setEditAnaliseAcaoIndicador] = useState();
  const [listaAnaliseIndicador, setListaAnaliseIndicador] = useState();
  const [isVisualizar, setIsVisualizar] = useState(false);
  const [actionModal, setActionModal] = useState({
    edit: false,
    disabled: false,
  });
  const [dadosApuracao, setDadosApuracao] = useState();
  const [isValidDate, setIsValidDate] = useState(true);
  let history = useHistory();

  useEffect(() => {
    if (
      props.dadosItemAcao?.ptaFiplan?.idenPtaFiplan !== null &&
      props.dadosItemAcao.ptaFiplan.idenPtaFiplan !== undefined
    ) {
      buscaIndicadorPorIdenPtaFiplan(props.dadosItemAcao?.ptaFiplan?.idenPtaFiplan).then((res) => {
        setListaIndicadores(res.data);
      });
    }
  }, [props.dadosItemAcao]);

  async function onChangeIndicador(e) {
    setIndicadorSelecionado(null);
    setDadosMetaPPA(null);
    setIndicadorSelecionado(e.value ? e.value : null);

    setAnaliseAcaoIndicador({
      idenPtaMonitora: null,
      idenPtaFiplanIndicador: null,
      tipoAnaliseAcaoIndicador: 0,
      descAnaliseAcaoIndicador: "",
      statAnaliseAcaoInd: 1,
      dataApuracao: "",
      valrApurado: 0,
    });
    await onChangebuscaAnaliseAcaoIndicador();
    if (e.value) {
      await buscarApuracaoByIndenIndicador(e.value.indicador.idenIndicador).then((res) => {
        setDadosApuracao({ ...res.data });
      });
    }
  }

  async function onChangebuscaAnaliseAcaoIndicador() {
    await buscaAnaliseAcaoIndicador(props.dadosItemAcao.idenPtaMonitora).then((res) => {
      setListaAnaliseIndicador(res.data);
    });
  }

  const selectedIndicadorTemplate = (option, props) => {
    if (option) {
      return (
        <div>
          <div>{option.indicador.codgIndicador + " - " + option.indicador.descIndicador}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const voltar = () => {
    history.push({ pathname: "/raglancamentos", state: {} });
  };

  const formartNumber = ({ valrMetaIndicadorObjetivo, descUnidadeMedida }) => {
    if (valrMetaIndicadorObjetivo >= 0) {
      if (descUnidadeMedida === "Percentual") {
        return (
          Number(valrMetaIndicadorObjetivo).toLocaleString("pt-BR", {
            style: "decimal",
            minimumFractionDigits: 3,
          }) + "%"
        );
      } else {
        return Number(valrMetaIndicadorObjetivo).toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 3,
        });
      }
    }

    return "Não informado";
  };

  const rejectFunc = () => {};

  function deleteAnaliseAcaoIndicador(rowData) {
    deletarAnaliseAcaoIndicador(rowData.analiseAcaoIndicador.idenAnaliseAcaoIndicador).then((res) => {
      onChangebuscaAnaliseAcaoIndicador();
      printToast({ summary: "Exclusão concluída", detail: "O registro foi excluído com sucesso" });
    });
  }

  const confirmaExclusao = (rowData) => {
    confirmDialog({
      message: "Deseja excluir este andamento?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => deleteAnaliseAcaoIndicador(rowData),
      reject: () => rejectFunc(),
    });
  };

  function editaAnaliseAcaoIndicador(rowData) {
    setEditAnaliseAcaoIndicador(rowData.analiseAcaoIndicador);
    setIsVisualizar(true);
    setActionModal({
      edit: true,
      disbled: false,
    });
  }

  function viewAnaliseAcaoIndicador(rowData) {
    setActionModal({ edit: false, disabled: true });
    setEditAnaliseAcaoIndicador(rowData.analiseAcaoIndicador);
    setIsVisualizar(true);
  }

  const acoesTemplate = (node, column) => {
    return (
      <>
        <button
          type="button"
          class="p-button p-component p-button-primary Raised p-button-icon-only"
          onClick={() => viewAnaliseAcaoIndicador(node)}
          style={{ justifyContent: "center" }}
        >
          <span class="p-button-icon p-c pi pi-eye"></span>
        </button>
        {props.podeAvaliarIndicador && (
          <>
            <button
              type="button"
              class="p-button p-component p-button-warning Raised p-button-icon-only"
              style={{ marginLeft: "5px", justifyContent: "center" }}
              onClick={() => editaAnaliseAcaoIndicador(node)}
            >
              <span class="p-button-icon p-c pi pi-pencil"></span>
            </button>
            <button
              type="button"
              class="p-button p-component p-button-danger Raised p-button-icon-only"
              style={{ marginLeft: "5px", justifyContent: "center" }}
              onClick={() => confirmaExclusao(node)}
            >
              <span class="p-button-icon p-c pi pi-trash"></span>
            </button>
          </>
        )}
      </>
    );
  };

  const salvarRagAnaliseAcaoIndicador = async () => {
    let newanaliseAcaoIndicador = {
      idenPtaMonitora: props.dadosItemAcao.idenPtaMonitora,
      idenPtaFiplanIndicador: indicadorSelecionado.idenPtaFiplanIndicador,
      tipoAnaliseAcaoIndicador: 0,
      descAnaliseAcaoIndicador: analiseAcaoIndicador.descAnaliseAcaoIndicador,
      statAnaliseAcaoInd: 1,
      dataApuracao: dadosApuracao?.dataApuracao ? dadosApuracao.dataApuracao : analiseAcaoIndicador.dataApuracao,
      valrApurado: 0,
    };

    if (dadosApuracao?.valorApuradoFormatado || analiseAcaoIndicador?.valrApurado) {
      newanaliseAcaoIndicador = {
        ...newanaliseAcaoIndicador,
        valrApurado:
          dadosApuracao?.valorApuradoFormatado != undefined
            ? parseFloat(dadosApuracao.valorApuradoFormatado.replace(",", "."))
            : parseFloat(analiseAcaoIndicador?.valrApurado) || null,
      };
    }

    if (!newanaliseAcaoIndicador.valrApurado) {
      return printToast({
        severity: "error",
        detail: "O valor ‘Realizado’ (Apuração) do Indicador deve ser informado",
      });
    }
    if (!newanaliseAcaoIndicador.dataApuracao) {
      return printToast({
        severity: "error",
        detail: "A ‘Data da Apuração’ do Indicador deve ser informada",
      });
    }

    if (newanaliseAcaoIndicador.descAnaliseAcaoIndicador.trim() == "") {
      return printToast({
        severity: "error",
        detail: "Análise de andamento do indicador da Ação do Indicador deve ser informada",
      });
    }

    await salvarAnaliseAcaoIndicador(newanaliseAcaoIndicador).then((res) => {
      printToast({ summary: "Ação Efetuada", detail: "Avaliação do indicador salva com sucesso" });
      onChangebuscaAnaliseAcaoIndicador();
    });

    setAnaliseAcaoIndicador({
      idenPtaMonitora: null,
      idenPtaFiplanIndicador: null,
      tipoAnaliseAcaoIndicador: 0,
      descAnaliseAcaoIndicador: "",
      statAnaliseAcaoInd: 1,
      dataApuracao: "",
      valrApurado: 0,
    });
  };

  const dataApuracaoTemplatePos = (rowData) => {
    if (rowData === undefined || rowData === null) return "*";

    return rowData.analiseAcaoIndicador?.dataApuracao ? rowData.analiseAcaoIndicador?.dataApuracao : "--/--/----";
  };

  const IndicadorTemplate = (rowData) => {
    if (rowData === undefined || rowData === null) return "*";

    return rowData.indicador?.codgIndicador + " - " + rowData.indicador?.descIndicador;
  };

  function previstoApuracaoTemplatePos(valor) {
    if (valor === undefined || valor === null) {
      return "*";
    }
    if (valor.indicador.valrMetaIndicadorAcao === "0.00") {
      return " - ";
    }
    return formartNumber({
      valrMetaIndicadorObjetivo: valor.indicador.valrMetaIndicadorAcao,
      descUnidadeMedida: valor.indicador.unidadeMedida?.descUnidadeMedida,
    });
  }

  function realizadoApuracaoTemplatePos(valor) {
    if (valor?.analiseAcaoIndicador?.valrApurado === undefined || valor?.analiseAcaoIndicador?.valrApurado === null) {
      return "*";
    }
    if (valor === "0.00") {
      return " - ";
    }
    return valor?.analiseAcaoIndicador?.valrApurado.toLocaleString("pt-BR", { minimumFractionDigits: 3 });
  }

  const editarRagAnaliseAcaoIndicador = async () => {
    await editarAnaliseAcaoIndicador(editAnaliseAcaoIndicador.idenAnaliseAcaoIndicador, editAnaliseAcaoIndicador).then(
      (res) => {
        printToast({ summary: "Ação Efetuada", detail: "Avaliação do indicador salva com sucesso" });
        onChangebuscaAnaliseAcaoIndicador();
        setIsVisualizar(false);
      }
    );
  };
  const validateDate = (value) => {
    const [day, month, year] = value.split("/");

    const dayInt = parseInt(day, 10);
    const monthInt = parseInt(month, 10);
    const yearInt = parseInt(year, 10);

    // Verifica se os valores são números válidos e dentro dos limites de dias, meses e anos
    if (isNaN(dayInt) || isNaN(monthInt) || isNaN(yearInt)) {
      return false;
    }

    if (dayInt < 1 || dayInt > 31 || monthInt < 1 || monthInt > 12 || yearInt < 1000 || yearInt > 9999) {
      return false;
    }

    // Verifica a quantidade de dias em cada mês (considera ano bissexto para fevereiro)
    const daysInMonth = new Date(yearInt, monthInt, 0).getDate();
    return dayInt <= daysInMonth;
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setAnaliseAcaoIndicador((prevState) => ({
      ...prevState,
      dataApuracao: e.target.value,
    }));

    // Valida a data
    if (newValue.length === 10) {
      // Só valida quando a máscara está completa
      setIsValidDate(validateDate(newValue));
    } else {
      setIsValidDate(true); // Evita marcar como inválido enquanto o usuário está digitando
    }
  };

  const calRealizado = () => {
    if (typeof dadosApuracao?.valorApuradoFormatado === "string") {
      if (Number(dadosApuracao.valorApuradoFormatado.replace(",", ".") > 0)) {
        return typeof dadosApuracao?.valorApuradoFormatado === "string"
          ? Number(dadosApuracao.valorApuradoFormatado.replace(",", "."))
          : Number(dadosApuracao?.valorApuradoFormatado ?? 0);
      }
    }

    if (analiseAcaoIndicador?.valrApurado == 0) {
      return 0;
    }

    if (typeof dadosApuracao?.valorApuradoFormatado === "string") {
      return parseFloat(analiseAcaoIndicador.valrApurado.replace(",", "."));
    }

    return analiseAcaoIndicador?.valrApurado;
  };

  const formatarMilhar = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  return (
    <>
      <CardSeplagScrol title="Indicador(es) da Ação">
        {isVisualizar && (
          <ModalSeplag
            titulo={"Análise de andamento do indicador da Ação"}
            type="NONE"
            tamanho="1200px"
            visible={isVisualizar}
            labelFechar="Fechar"
            fechar={() => {
              setIsVisualizar(false);
              setAnaliseAcaoIndicador();
              setEditAnaliseAcaoIndicador();
              setActionModal({
                edit: false,
                disbled: false,
                create: false,
              });
            }}
          >
            <div className="grid-container" style={{ display: "flex", padding: "1rem" }}>
              <div className="field col-2">
                <RotuloSeplag obrigatorio nome="Realizado:">
                  <InputNumber
                    inputId="locale-br"
                    locale="pt-BR"
                    minFractionDigits={3}
                    value={editAnaliseAcaoIndicador?.valrApurado}
                    onChange={(e) => {
                      if (e.value == null || e.value == undefined) {
                        return setEditAnaliseAcaoIndicador((prevState) => ({
                          ...prevState,
                          valrApurado: 0,
                        }));
                      }
                      setEditAnaliseAcaoIndicador((prevState) => ({
                        ...prevState,
                        valrApurado: e.value,
                      }));
                    }}
                    disabled={
                      actionModal.edit === true
                        ? !props.podeAvaliarIndicador === false
                          ? !!dadosApuracao?.dataApuracao
                          : true
                        : true
                    }
                  />
                </RotuloSeplag>
              </div>
              <div className="field col-2">
                <RotuloSeplag obrigatorio nome="Data da Apuração:">
                  <InputMask
                    disabled={
                      actionModal.edit === true
                        ? !props.podeAvaliarIndicador === false
                          ? !!dadosApuracao?.dataApuracao
                          : true
                        : true
                    }
                    mask="99/99/9999"
                    slotChar="__/__/____"
                    placeholder="__/__/____"
                    id="dataApuracao"
                    value={editAnaliseAcaoIndicador?.dataApuracao}
                    onChange={(e) => {
                      if (e.value == null || e.value == undefined) {
                        return setEditAnaliseAcaoIndicador((prevState) => ({
                          ...prevState,
                          dataApuracao: "",
                        }));
                      }
                      setEditAnaliseAcaoIndicador((prevState) => ({
                        ...prevState,
                        dataApuracao: e.value,
                      }));
                    }}
                    className={isValidDate ? "" : "p-invalid"}
                  />
                  {!isValidDate && <small className="p-error">Data inválida</small>}
                </RotuloSeplag>
              </div>
            </div>
            <RotuloSeplag nome="Análise de andamento do indicador da Ação">
              <span className="p-float-label">
                <InputTextarea
                  rows={5}
                  cols={10}
                  id="idenAnaliseAcaoIndicador"
                  value={editAnaliseAcaoIndicador?.descAnaliseAcaoIndicador}
                  onChange={(e) => {
                    setEditAnaliseAcaoIndicador((prevState) => ({
                      ...prevState,
                      descAnaliseAcaoIndicador: e.target.value,
                    }));
                  }}
                  readOnly={
                    actionModal.edit === true
                      ? props.podeAvaliarIndicador === false
                        ? !!dadosApuracao?.dataApuracao
                        : false
                      : true
                  }
                />
                <span className="contador-caracteres">
                  {formatarMilhar(
                    qtdMaxCaracteres -
                      (editAnaliseAcaoIndicador?.descAnaliseAcaoIndicador
                        ? editAnaliseAcaoIndicador?.descAnaliseAcaoIndicador.length
                        : 0)
                  )}{" "}
                  caracteres restantes
                </span>
              </span>
            </RotuloSeplag>

            <div className="grid grid-bottom" style={{ margin: "1rem", paddingTop: "1rem" }}>
              {actionModal.edit && (
                <>
                  <div className="col">
                    <Button label="Alterar" onClick={() => editarRagAnaliseAcaoIndicador()} />
                  </div>
                  <div className="col">
                    <Button
                      label={"Cancelar"}
                      className="p-button-secondary"
                      onClick={() => {
                        setIsVisualizar(false);
                        setAnaliseAcaoIndicador();
                        setEditAnaliseAcaoIndicador();
                        setActionModal({
                          edit: false,
                          disbled: false,
                          create: false,
                        });
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </ModalSeplag>
        )}

        <ConfirmDialog />
        <div className="p-fluid grid">
          <div className="field col-12">
            <RotuloSeplag nome="Indicador">
              <Dropdown
                emptyMessage="Dados não encontrados"
                itemTemplate={selectedIndicadorTemplate}
                valueTemplate={selectedIndicadorTemplate}
                emptyFilterMessage="Opção não encontrada"
                id="indicador.codgIndicador"
                value={indicadorSelecionado}
                options={listaIndicadores}
                onChange={(e) => onChangeIndicador(e)}
                optionLabel="indicador.descIndicador"
                filter
                showClear
                filterBy="indicador.descIndicador"
                placeholder="Selecione um Indicador"
              />
            </RotuloSeplag>
          </div>

          {indicadorSelecionado !== null && (
            <>
              <div className="field col-1">
                <RotuloSeplag nome="Código:">
                  <label>{indicadorSelecionado.indicador?.codgIndicador}</label>
                </RotuloSeplag>
              </div>
              <div className="field col-2">
                <RotuloSeplag nome="Fonte de apuração:">
                  <label>{indicadorSelecionado.indicador?.descFonteApuracao}</label>
                </RotuloSeplag>
              </div>
              <div className="field col-3">
                <RotuloSeplag nome="Período de apuração:">
                  <label>{indicadorSelecionado.indicador?.flagPeriodicidade}</label>
                </RotuloSeplag>
              </div>
              <div className="field col-3">
                <RotuloSeplag nome="Unidade de medida:">
                  <label>
                    {indicadorSelecionado.indicador?.unidadeMedida
                      ? indicadorSelecionado.indicador?.unidadeMedida?.descUnidadeMedida
                      : ""}
                  </label>
                </RotuloSeplag>
              </div>
              <div className="field col-3">
                <RotuloSeplag nome="Sentido/Polaridade:">
                  <label>
                    {indicadorSelecionado.indicador?.descPolaridade
                      ? indicadorSelecionado.indicador?.descPolaridade
                      : ""}
                  </label>
                </RotuloSeplag>
              </div>
              <div className="field col-3">
                <RotuloSeplag nome="Base Geográfica:">
                  <label>{indicadorSelecionado.indicador?.flagBaseGeografica}</label>
                </RotuloSeplag>
              </div>
              <div className="field col-9">
                <RotuloSeplag nome="Fórmula de cálculo do Indicador:">
                  <label>{indicadorSelecionado.indicador?.descFormulaCalculo}</label>
                </RotuloSeplag>
              </div>
              <Fieldset legend="Apuração do Indicador" className="field col-12">
                <div className="p-fluid grid">
                  <div className="field col-6">
                    <RotuloSeplag nome="Descrição:">
                      <label>
                        {indicadorSelecionado.indicador?.codgIndicador +
                          " - " +
                          indicadorSelecionado.indicador?.descIndicador}
                      </label>
                    </RotuloSeplag>
                  </div>
                  <div className="field col-2">
                    <RotuloSeplag nome="Previsto:">
                      <label>
                        {formartNumber({
                          valrMetaIndicadorObjetivo: indicadorSelecionado.indicador?.valrMetaIndicadorAcao,
                          descUnidadeMedida: indicadorSelecionado.indicador.unidadeMedida?.descUnidadeMedida,
                        })}
                      </label>
                    </RotuloSeplag>
                  </div>
                  <div className="field col-2">
                    <RotuloSeplag obrigatorio nome="Realizado:">
                      <InputNumber
                        inputId="locale-br"
                        locale="pt-BR"
                        minFractionDigits={3}
                        value={calRealizado()}
                        onChange={(e) => {
                          if (e.value == null || e.value == undefined) {
                            return setAnaliseAcaoIndicador((prevState) => ({
                              ...prevState,
                              valrApurado: 0,
                            }));
                          }
                          // let valorFormatado = e.value.toLocaleString("pt-BR", {
                          //   minimumFractionDigits: 3,
                          //   maximumFractionDigits: 3,
                          // });
                          setAnaliseAcaoIndicador((prevState) => ({
                            ...prevState,
                            valrApurado: e.value,
                          }));
                        }}
                        disabled={!props.podeAvaliarIndicador == false ? !!dadosApuracao?.dataApuracao : true}
                      />
                    </RotuloSeplag>
                  </div>
                  <div className="field col-2">
                    <RotuloSeplag obrigatorio nome="Data da Apuração:">
                      <InputMask
                        disabled={!props.podeAvaliarIndicador == false ? !!dadosApuracao?.dataApuracao : true}
                        mask="99/99/9999"
                        slotChar="__/__/____"
                        placeholder="__/__/____"
                        id="dataApuracao"
                        value={dadosApuracao?.dataApuracao ?? analiseAcaoIndicador?.dataApuracao}
                        onChange={handleChange}
                        className={isValidDate ? "" : "p-invalid"}
                      />
                      {!isValidDate && <small className="p-error">Data inválida</small>}
                    </RotuloSeplag>
                  </div>
                </div>
                <RotuloSeplag obrigatorio nome="Análise de andamento do indicador da Ação">
                  <label>
                    <InputTextarea
                      id="descAnalisadeAndamentoIndicador"
                      value={analiseAcaoIndicador?.descAnaliseAcaoIndicador}
                      onChange={(e) => {
                        setAnaliseAcaoIndicador((prevState) => ({
                          ...prevState,
                          descAnaliseAcaoIndicador: e.target.value,
                        }));
                      }}
                      disabled={!props.podeAvaliarIndicador}
                    />
                    <span className="contador-caracteres">
                      {formatarMilhar(
                        qtdMaxCaracteres -
                          (analiseAcaoIndicador?.descAnaliseAcaoIndicador
                            ? analiseAcaoIndicador?.descAnaliseAcaoIndicador.length
                            : 0)
                      )}{" "}
                      caracteres restantes
                    </span>
                  </label>
                </RotuloSeplag>
              </Fieldset>
              <div className="field col-12 md:col-8 ">&nbsp;</div>
              <div className="field col-12 md:col-2 ">
                <Button label="Voltar" className="p-button-secondary" onClick={voltar} />
              </div>
              <div className="field col-12 md:col-2 ">
                {props.podeAvaliarIndicador && (
                  <Button label="Salvar" className="p-button-success" onClick={salvarRagAnaliseAcaoIndicador} />
                )}
              </div>
            </>
          )}
        </div>
        {indicadorSelecionado !== null && (
          <DataTable
            emptyMessage="Não foram encontradas análises de andamento para este item"
            value={listaAnaliseIndicador}
          >
            <Column body={IndicadorTemplate} header="Indicador" style={{ minWidth: "10%" }} />
            <Column
              field="pos4.valrMetaIndicadorObjetivo"
              body={previstoApuracaoTemplatePos}
              header="Previsto"
              style={{ minWidth: "5%" }}
            />
            <Column
              field="analiseAcaoIndicador.valrApurado"
              body={realizadoApuracaoTemplatePos}
              header="Realizado"
              style={{ minWidth: "5%" }}
            />
            <Column body={dataApuracaoTemplatePos} header="Data da Apuração" style={{ minWidth: "10%" }} />
            <Column
              field="analiseAcaoIndicador.descAnaliseAcaoIndicador"
              header="Análise de andamento do indicador da Ação"
              body={(rowData) => {
                const text = rowData.analiseAcaoIndicador?.descAnaliseAcaoIndicador || "";
                return text.length > 300 ? text.substring(0, 300) + "..." : text;
              }}
              style={{ minWidth: "4%" }}
            />
            <Column
              body={acoesTemplate}
              headerStyle={{ textAlign: "center" }}
              field="idenAnaliseAcaoIndicador"
              header="Ações"
              style={{ minWidth: "10%" }}
            />
          </DataTable>
        )}
      </CardSeplagScrol>
    </>
  );
};
export default AvaliacaoAcaoRagIndicador;
